import React from "react";
import DfrDashboard from "./dfrDashboard";
import { DfrThemeProvider } from "./dfrTheme";

export default function DfrApp() {
    return (
        <DfrThemeProvider>
            <DfrDashboard />
        </DfrThemeProvider>
    );
}
